import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import classnames from 'classnames';
import React__default, { useContext } from 'react';
import { TabsContext } from './index.js';

var _excluded = ["as", "className", "name", "active"];

// Single Tab
var TabsItem = function TabsItem(_ref) {
  var _ref$as = _ref.as,
    As = _ref$as === void 0 ? 'button' : _ref$as,
    className = _ref.className,
    name = _ref.name,
    _ref$active = _ref.active,
    active = _ref$active === void 0 ? false : _ref$active,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useContext = useContext(TabsContext),
    activeTab = _useContext.activeTab,
    onTabSelect = _useContext.onTabSelect;
  var finalClasses = classnames('C-Tabs__Button', {
    isSelected: active || name && activeTab && name === activeTab
  }, className);
  return /*#__PURE__*/React__default.createElement(As, _extends({
    className: finalClasses,
    role: "tab",
    type: As === 'button' ? 'button' : null,
    "aria-selected": active || name && activeTab && name === activeTab,
    "aria-controls": "".concat(name, "-tab-panel"),
    id: "".concat(name, "-tab-control"),
    tabIndex: active || name && activeTab && name === activeTab ? 0 : -1,
    onClick: onTabSelect(name)
  }, otherProps));
};
TabsItem.displayName = 'Tabs.Item';

export { TabsItem, TabsItem as default };
